import { render, staticRenderFns } from "./PopupBlockedDialog.vue?vue&type=template&id=873bc466&"
import script from "./PopupBlockedDialog.vue?vue&type=script&lang=js&"
export * from "./PopupBlockedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports